import React from "react";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBIcon,
  MDBSpinner,
  MDBRow,
  MDBCol,
} from "mdb-react-ui-kit";

import { doFetchJson } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";

const EMPTY_FORM = {
  idCustomer: null,
  name: "",
  phone: "",
  email: "",
  notes: "",
  identificationType: "",
  identificationNumber: "",
  address: "",
  city: "",
  postalCode: "",
  country: "",
};

/**
 * CustomersModal — Gestión del catálogo de clientes/compradores.
 *
 * Props:
 *  - show: boolean
 *  - onClose: () => void
 */
class CustomersModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      loading: false,
      search: "",
      formCustomer: null,   // null = lista; objeto = crear/editar
      showExtra: false,
      saving: false,
      confirmDelete: null,
    };
    this.searchTimer = null;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      this.setState({ search: "", formCustomer: null, confirmDelete: null }, this.loadCustomers);
    }
  }

  handleClose = () => {
    if (this.props.onClose) this.props.onClose();
  };

  loadCustomers = () => {
    this.setState({ loading: true });
    const q = this.state.search.trim();
    const qs = q ? "?q=" + encodeURIComponent(q) + "&limit=50" : "?limit=50";
    doFetchJson("TEAN", "getCustomers" + qs)
      .then((json) => {
        this.setState({ customers: (json && json.STATE === "SUCCESS" && Array.isArray(json.DATA)) ? json.DATA : [] });
      })
      .catch(() => this.setState({ customers: [] }))
      .finally(() => this.setState({ loading: false }));
  };

  handleSearchChange = (e) => {
    const v = e.target.value;
    this.setState({ search: v });
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(this.loadCustomers, 350);
  };

  openCreate = () => this.setState({ formCustomer: { ...EMPTY_FORM }, showExtra: false });
  openEdit = (c) =>
    this.setState({
      formCustomer: {
        idCustomer: c.idCustomer,
        name: c.name || "",
        phone: c.phone || "",
        email: c.email || "",
        notes: c.notes || "",
        identificationType: c.identificationType || "",
        identificationNumber: c.identificationNumber || "",
        address: c.address || "",
        city: c.city || "",
        postalCode: c.postalCode || "",
        country: c.country || "",
      },
      showExtra: false,
    });

  closeForm = () => this.setState({ formCustomer: null });

  updateField = (field) => (e) =>
    this.setState((prev) => ({
      formCustomer: { ...prev.formCustomer, [field]: e.target.value },
    }));

  handleSave = () => {
    const { formCustomer } = this.state;
    if (!formCustomer.name.trim()) {
      toast.show({ message: "El nombre es obligatorio", type: "warning" });
      return;
    }
    this.setState({ saving: true });
    const isNew = !formCustomer.idCustomer;
    const endpoint = isNew ? "createCustomer" : "updateCustomer";
    const method = isNew ? "POST" : "PUT";
    doFetchJson("TEAN", endpoint, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formCustomer),
    })
      .then((json) => {
        if (json && json.STATE === "SUCCESS") {
          toast.show({ message: isNew ? "Cliente creado" : "Cliente actualizado", type: "success" });
          this.setState({ formCustomer: null }, this.loadCustomers);
        } else {
          toast.show({ message: (json && json.MESSAGE) || "Error al guardar", type: "danger" });
        }
      })
      .catch(() => toast.show({ message: "Error de red", type: "danger" }))
      .finally(() => this.setState({ saving: false }));
  };

  askDelete = (c) => this.setState({ confirmDelete: c });
  cancelDelete = () => this.setState({ confirmDelete: null });

  confirmDeleteNow = () => {
    const { confirmDelete } = this.state;
    if (!confirmDelete) return;
    this.setState({ saving: true });
    doFetchJson("TEAN", "deleteCustomer/" + confirmDelete.idCustomer, { method: "DELETE" })
      .then((json) => {
        if (json && json.STATE === "SUCCESS") {
          toast.show({ message: "Cliente eliminado", type: "success" });
          this.setState({ confirmDelete: null }, this.loadCustomers);
        } else {
          toast.show({ message: (json && json.MESSAGE) || "Error al eliminar", type: "danger" });
          this.setState({ confirmDelete: null });
        }
      })
      .catch(() => {
        toast.show({ message: "Error de red", type: "danger" });
        this.setState({ confirmDelete: null });
      })
      .finally(() => this.setState({ saving: false }));
  };

  renderForm() {
    const { formCustomer, showExtra, saving } = this.state;
    return (
      <>
        <div className="d-flex align-items-center mb-3">
          <MDBBtn size="sm" color="light" onClick={this.closeForm} className="me-2">
            <MDBIcon fas icon="arrow-left" className="me-1" />
            Volver
          </MDBBtn>
          <h6 className="mb-0">
            {formCustomer.idCustomer ? "Editar cliente" : "Nuevo cliente"}
          </h6>
        </div>

        <MDBRow className="g-2">
          <MDBCol size="12">
            <label className="form-label small">Nombre *</label>
            <input
              className="form-control form-control-sm"
              value={formCustomer.name}
              onChange={this.updateField("name")}
              maxLength={150}
              placeholder="Nombre completo"
            />
          </MDBCol>
          <MDBCol size="12" md="6">
            <label className="form-label small">Teléfono</label>
            <input
              className="form-control form-control-sm"
              value={formCustomer.phone}
              onChange={this.updateField("phone")}
              maxLength={50}
              placeholder="+34 600 000 000"
            />
          </MDBCol>
          <MDBCol size="12" md="6">
            <label className="form-label small">Email</label>
            <input
              type="email"
              className="form-control form-control-sm"
              value={formCustomer.email}
              onChange={this.updateField("email")}
              maxLength={150}
              placeholder="correo@ejemplo.com"
            />
          </MDBCol>
          <MDBCol size="12">
            <label className="form-label small">Notas</label>
            <textarea
              className="form-control form-control-sm"
              rows={2}
              value={formCustomer.notes}
              onChange={this.updateField("notes")}
              placeholder="Observaciones internas..."
            />
          </MDBCol>
        </MDBRow>

        <div className="mt-2">
          <MDBBtn
            size="sm"
            color="link"
            className="ps-0"
            onClick={() => this.setState((p) => ({ showExtra: !p.showExtra }))}
          >
            <MDBIcon fas icon={showExtra ? "chevron-up" : "chevron-down"} className="me-1" />
            {showExtra ? "Ocultar datos adicionales" : "Más datos (identificación, dirección...)"}
          </MDBBtn>
        </div>

        {showExtra && (
          <MDBRow className="g-2 mt-1">
            <MDBCol size="12" md="4">
              <label className="form-label small">Tipo de identificación</label>
              <select
                className="form-select form-select-sm"
                value={formCustomer.identificationType}
                onChange={this.updateField("identificationType")}
              >
                <option value="">—</option>
                <option value="DNI">DNI</option>
                <option value="NIE">NIE</option>
                <option value="PASSPORT">Pasaporte</option>
                <option value="OTHER">Otro</option>
              </select>
            </MDBCol>
            <MDBCol size="12" md="8">
              <label className="form-label small">Nº de identificación</label>
              <input
                className="form-control form-control-sm"
                value={formCustomer.identificationNumber}
                onChange={this.updateField("identificationNumber")}
                maxLength={50}
              />
            </MDBCol>
            <MDBCol size="12">
              <label className="form-label small">Dirección</label>
              <input
                className="form-control form-control-sm"
                value={formCustomer.address}
                onChange={this.updateField("address")}
                maxLength={255}
              />
            </MDBCol>
            <MDBCol size="12" md="5">
              <label className="form-label small">Ciudad</label>
              <input
                className="form-control form-control-sm"
                value={formCustomer.city}
                onChange={this.updateField("city")}
                maxLength={100}
              />
            </MDBCol>
            <MDBCol size="12" md="3">
              <label className="form-label small">Código postal</label>
              <input
                className="form-control form-control-sm"
                value={formCustomer.postalCode}
                onChange={this.updateField("postalCode")}
                maxLength={20}
              />
            </MDBCol>
            <MDBCol size="12" md="4">
              <label className="form-label small">País</label>
              <input
                className="form-control form-control-sm"
                value={formCustomer.country}
                onChange={this.updateField("country")}
                maxLength={80}
              />
            </MDBCol>
          </MDBRow>
        )}

        <div className="d-flex justify-content-end gap-2 mt-3">
          <MDBBtn color="secondary" outline size="sm" onClick={this.closeForm} disabled={saving}>
            Cancelar
          </MDBBtn>
          <MDBBtn color="primary" size="sm" onClick={this.handleSave} disabled={saving}>
            {saving ? <MDBSpinner size="sm" className="me-1" /> : <MDBIcon fas icon="save" className="me-1" />}
            Guardar
          </MDBBtn>
        </div>
      </>
    );
  }

  renderList() {
    const { customers, loading, search } = this.state;
    return (
      <>
        <div className="d-flex gap-2 mb-3">
          <div className="flex-grow-1 position-relative">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar por nombre, teléfono o email..."
              value={search}
              onChange={this.handleSearchChange}
            />
            {loading && (
              <MDBSpinner size="sm" style={{ position: "absolute", right: 10, top: 7 }} />
            )}
          </div>
          <MDBBtn size="sm" color="primary" onClick={this.openCreate}>
            <MDBIcon fas icon="user-plus" className="me-1" />
            Nuevo
          </MDBBtn>
        </div>

        {!loading && customers.length === 0 && (
          <div className="text-center text-muted py-4 fst-italic small">
            {search ? "Sin resultados para la búsqueda." : "No hay clientes registrados."}
          </div>
        )}

        {customers.length > 0 && (
          <div className="table-responsive">
            <table className="table table-sm table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Email</th>
                  <th className="text-end">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {customers.map((c) => (
                  <tr key={c.idCustomer}>
                    <td>{c.name}</td>
                    <td className="text-muted small">{c.phone || "—"}</td>
                    <td className="text-muted small">{c.email || "—"}</td>
                    <td className="text-end">
                      <MDBBtn
                        size="sm"
                        color="light"
                        className="me-1"
                        title="Editar"
                        onClick={() => this.openEdit(c)}
                      >
                        <MDBIcon fas icon="pen" />
                      </MDBBtn>
                      <MDBBtn
                        size="sm"
                        color="light"
                        title="Eliminar"
                        onClick={() => this.askDelete(c)}
                      >
                        <MDBIcon fas icon="trash" className="text-danger" />
                      </MDBBtn>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </>
    );
  }

  render() {
    const { show } = this.props;
    const { formCustomer, confirmDelete, saving } = this.state;

    return (
      <>
        <MDBModal show={show} onHide={this.handleClose} tabIndex="-1">
          <MDBModalDialog size="lg" centered>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>
                  <MDBIcon fas icon="users" className="me-2" />
                  Clientes
                </MDBModalTitle>
                <MDBBtn className="btn-close" color="none" onClick={this.handleClose} />
              </MDBModalHeader>
              <MDBModalBody>
                {formCustomer ? this.renderForm() : this.renderList()}
              </MDBModalBody>
              {!formCustomer && (
                <MDBModalFooter>
                  <MDBBtn color="secondary" outline onClick={this.handleClose}>
                    Cerrar
                  </MDBBtn>
                </MDBModalFooter>
              )}
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

        <MDBModal show={!!confirmDelete} onHide={this.cancelDelete} tabIndex="-1">
          <MDBModalDialog centered>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>
                  <MDBIcon fas icon="exclamation-triangle" className="text-warning me-2" />
                  Eliminar cliente
                </MDBModalTitle>
                <MDBBtn className="btn-close" color="none" onClick={this.cancelDelete} />
              </MDBModalHeader>
              <MDBModalBody>
                ¿Eliminar a <strong>"{confirmDelete ? confirmDelete.name : ""}"</strong>?
                <div className="text-muted small mt-1">
                  El historial de entradas asociado se conserva.
                </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" outline onClick={this.cancelDelete} disabled={saving}>
                  Cancelar
                </MDBBtn>
                <MDBBtn color="danger" onClick={this.confirmDeleteNow} disabled={saving}>
                  {saving ? <MDBSpinner size="sm" className="me-1" /> : <MDBIcon fas icon="trash" className="me-1" />}
                  Eliminar
                </MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}

export default CustomersModal;
